export const HomeCodeIcon = require('./home-code.svg').default;
export const Intelli1Icon = require('./intelli_01.png');
export const Intelli2Icon = require('./intelli_02.png');
export const Intelli3Icon = require('./intelli_03.png');
export const Intelli4Icon = require('./intelli_04.png');
export const Intelli5Icon = require('./intelli_05.png');
export const JpMorgon1Icon = require('./jp_01.png');
export const JpMorgon2Icon = require('./jp_02.png');
export const JpMorgon3Icon = require('./jp_03.png');
export const LocalPower1Icon = require('./lp_01.png');
export const LocalPower2Icon = require('./lp_02.png');
export const LocalPower3Icon = require('./lp_03.png');
export const LocalPower4Icon = require('./lp_04.png');
export const VB1Icon = require('./vb_01.webp');
export const VB2Icon = require('./vb_02.png');
export const Ml1Icon = require('./mealpackz_01.webp');
export const Ml2Icon = require('./mealpackz_02.png');
export const Ml3Icon = require('./mealpackz_03.webp');
export const BL1Icon = require('./bellesa_01.webp');
export const BL2Icon = require('./bellesa_02.webp');
export const BL3Icon = require('./bellesa_03.webp');
export const BSG1Icon = require('./bsg_01.png');
export const BSG2Icon = require('./bsg_02.webp');
export const UG1Icon = require('./ug_01.png');
export const UG2Icon = require('./ug_02.png');
export const UG3Icon = require('./ug_03.png');
export const UG4Icon = require('./ug_04.png');
export const UG5Icon = require('./ug_05.png');                   
export const JP1Icon = require('./jp_01.png');                   
export const JP2Icon = require('./jp_02.png');                   
export const JP3Icon = require('./jp_03.png');                   
export const CV = require('./Fullstack_Nishit_Raval_CV_2025.pdf');                   